export const IO_CARDS = [
    {
      id: 1,
      appCode: "ssa",
      title: "Safety Stock Approval",
      disabled: false,
      url: process.env.REACT_APP_SSA_URL,
      className: 'ssa'
    },
    {
      id: 2,
      appCode: "kpi",
      title: "KPI Metrics",
      url: "",
      disabled: false,
      className: 'kpi'
    }
  ];